'use client'

import { configureHotmartAffiliate } from '@/utils/hotmart'
import { RED_TESTING_CONFIG } from '@/constants/redtesting-config'
import { Lab } from 'rvbr-www/red-testing'
import envs from '../../envs'
import { noticeError } from '@/utils/newRelic'

import { Roboto, Barlow_Condensed } from 'next/font/google'
import { useEffect, useState } from 'react'

import Script from 'next/script'
import analytics from '@/utils/analytics'

import { GoogleTagManager } from '@next/third-parties/google'
import { handleNewRelicReady } from '@/utils/newRelic'

import { GA4, fbPixel, tiktokPixel } from '@/utils/scripts'

import '@/styles/index.scss'
import { basePath } from '../../next.config'

const roboto = Roboto({
  weight: ['400', '500', '700', '900'],
  subsets: ['latin'],
  variable: '--font-family-roboto',
  display: 'swap'
})

const barlow = Barlow_Condensed({
  weight: ['700'],
  subsets: ['latin'],
  variable: '--font-family-barlow',
  display: 'swap'
})

const isProd = process.env.NEXT_PUBLIC_BUILD_ENV === 'production'

export default function RootLayout({ children }) {
  const [isWebView, setIsWebView] = useState(false)

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    setIsWebView(/Instagram/.test(userAgent))

    configureHotmartAffiliate()

    analytics.setup({
      shortUrls: ['saiba-mais', 'lapa-team'],
      tracrConfig: {
        clientId: envs?.TRACR_CLIENT_ID,
        appKey: envs?.TRACR_APP_KEY,
        environment: envs?.ENVIRONMENT_ID
      }
    })

    const sourceUrl = localStorage.getItem('sourceUrl')

    if (!sourceUrl) {
      noticeError(`sourceUrl not found in app layout: ${sourceUrl}`)
    }
  }, [])

  return (
    <html
      lang="pt-br"
      suppressHydrationWarning={true}
      className={`${roboto.variable} ${barlow.variable}`}
    >
      <head>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="A maior academia de aulas online ao vivo do mundo. Treine com o método único do Lapa Team, que já mudou a vida de milhares de pessoas e que transformou o corpo de famosas, como a Jade Picon, a Bruna Griphao, e de muitas outras."
        />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <link rel="canonical" href="https://academiafoguete.com.br" />
        <title>
          Academia Foguete | Transforme seu corpo com treinos online
        </title>
        <meta
          httpEquiv="Content-Security-Policy"
          content={`
            frame-src 'self' https://*.youtube.com https://*.hotmart.com https://*.pandavideo.com.br;
            font-src 'self' data:;
          `}
        />
        <link rel="preconnect" href="https://www.google.com" />
        {isWebView && (
          <>
            <meta httpEquiv="cache-control" content="max-age=0" />
            <meta httpEquiv="pragma" content="no-cache" />
            <meta httpEquiv="expires" content="0" />
          </>
        )}
      </head>

      <body className="home" suppressHydrationWarning={true}>
        <Lab config={RED_TESTING_CONFIG}>{children}</Lab>

        {isProd && (
          <>
            <GoogleTagManager gtmId={envs?.GTM_ID} async />

            <Script id={GA4.scriptId} strategy="afterInteractive">
              {GA4.scriptSetup}
            </Script>

            <Script strategy="afterInteractive" id={fbPixel.scriptId}>
              {fbPixel.script}
            </Script>

            <Script strategy="afterInteractive" id={tiktokPixel.scriptId}>
              {tiktokPixel.script}
            </Script>

            <Script
              strategy="afterInteractive"
              id="new-relic"
              src={`${basePath}/js/new-relic.js`}
              type="text/javascript"
              onReady={handleNewRelicReady}
            />

            <noscript
              dangerouslySetInnerHTML={{ __html: fbPixel.noscript }}
            ></noscript>
          </>
        )}
      </body>
    </html>
  )
}
